import React, { useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const stripHtml = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

const FutureDataSection = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const paginationRef = useRef(null);

  useEffect(() => {
    const swiper = swiperRef.current.swiper;
    const timer = setTimeout(() => {
      if (
        swiperRef.current &&
        swiperRef.current.swiper &&
        prevRef.current &&
        nextRef.current &&
        paginationRef.current
      ) {
        // Bind navigation and pagination refs AFTER mount
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.params.pagination.el = paginationRef.current;

        swiper.navigation.destroy();
        swiper.navigation.init();
        swiper.navigation.update();

        swiper.pagination.destroy();
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      }
    }, 0); // let DOM update first

    return () => clearTimeout(timer);
  }, [data]);

  return (
    <section className="services_sec about_future_data_sec">
      <Swiper
        ref={swiperRef}
        className="aboutsky47_slider"
        slidesPerView={1}
        loop={true}
        modules={[Navigation, Pagination, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          el: paginationRef.current,
          clickable: true,
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          if (isNaN(swiperRef.activeIndex)) {
            swiper.slideTo(0);
          }
        }}
        onSlideChange={() => {
          if (isNaN(swiperRef.current?.activeIndex)) {
            swiperRef.current.activeIndex = 0;
          }
        }}
        breakpoints={{
          1060: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          480: { slidesPerView: 1, spaceBetween: 20 },
          100: { slidesPerView: 1, spaceBetween: 20 },
        }}
      >
        {data?.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="aboutsky47_futuredata_item">
              <div className="frame-group-wrapper">
                <div className="frame-group">
                  <div className="frame-ellipse"></div>
                  <div className="frame-div"></div>
                  <div className="frame-ellipse-2"></div>
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item?.acf?.post_icon || ""),
                }}
                className="box_img_left"
              />
              <div className="box_content_right">
                <h4
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item?.title?.rendered || ""),
                  }}
                />
                <p>{stripHtml(item?.content?.rendered)}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Nav Buttons with refs */}
      <div className="nav_button prev" ref={prevRef}>
        <img
          className="dark_left"
          src="https://47.activ8.digital/wp-content/uploads/2025/08/dark_left.png"
          width={72}
          height={52}
          alt="Prev"
        />
        <img
          className="light_left"
          src="https://47.activ8.digital/wp-content/uploads/2025/08/light_left.png"
          width={72}
          height={52}
          alt="Prev"
        />
      </div>
      <div className="nav_button next" ref={nextRef}>
        <img
          className="dark_right"
          src="https://47.activ8.digital/wp-content/uploads/2025/08/dark_right.png"
          width={72}
          height={52}
          alt="Next"
        />
        <img
          className="light_right"
          src="https://47.activ8.digital/wp-content/uploads/2025/08/light_right.png"
          width={72}
          height={52}
          alt="Next"
        />
      </div>

      <div className="swiper-pagination" ref={paginationRef}></div>
    </section>
  );
};

export default FutureDataSection;
